import { Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material"
import { format } from "date-fns"
import { ja } from "date-fns/locale"
import React from "react"
import { WeekLongString } from "../../Helper/Week"
import { LessonReservable } from "../../Objects/OnlineLesson"

export interface LessonReservableItemProps {
    lessonReservable: LessonReservable
    onEdit?: () => void
    onDelete?: () => void
}

const LessonReservableItem: React.FC<LessonReservableItemProps> = ({
    lessonReservable,
    onEdit,
    onDelete,
}) => {
    return (
        <Card variant="outlined" sx={{
            height: "100%"
        }}>
            <CardContent>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography align="right">[{lessonReservable.lrvable_id}]</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography>{WeekLongString[lessonReservable.week_conditions]}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography align="right">{lessonReservable.start.toStringHM()}〜{lessonReservable.end.toStringHM()}</Typography>
                    </Grid>
                    {lessonReservable.start_apply &&
                        <>
                            <Grid item xs={4}>
                                <Typography>適用開始日</Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography align="right">{format(lessonReservable.start_apply, 'yyyy年MM月dd日 (EE)', {locale: ja})}</Typography>
                            </Grid>
                        </>
                    }
                    {lessonReservable.end_apply &&
                        <>
                            <Grid item xs={4}>
                                <Typography>適用終了日</Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography align="right">{format(lessonReservable.end_apply, 'yyyy年MM月dd日 (EE)', {locale: ja})}</Typography>
                            </Grid>
                        </>
                    }
                </Grid>
            </CardContent>
            <CardActions sx={{
                display: "flex",
                justifyContent: "right"
            }}>
                {onEdit &&
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={()=>{
                            onEdit()
                        }}
                    >変更</Button>
                }
                {onDelete &&
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={()=>{
                            onDelete()
                        }}
                    >削除</Button>
                }
            </CardActions>
        </Card>
    )
}

export default LessonReservableItem